import { PropsWithChildren, ReactNode } from 'react';
import { useController } from 'react-hook-form';

import { SelectProps } from '@mui/material';
import { Select as SelectInput, type SelectInputProps } from 'common/components/Inputs/Select';

type Props<T> = Omit<SelectInputProps<T>, 'value' | 'onChange'> &
  Pick<SelectProps<T>, 'required' | 'defaultValue'> & {
    name: string;
    shouldShowError?: boolean;
    onChange?(value: T, child: ReactNode): void;
  };

export const Select = <T,>({
  name,
  required,
  defaultValue,
  onChange: onChangeEffect,
  ...props
}: PropsWithChildren<Props<T>>) => {
  const {
    field: { value = '', onChange, ref },
    fieldState: { error },
  } = useController({ name, defaultValue, rules: { required } });

  return (
    <SelectInput
      {...props}
      name={name}
      onChange={(e, child) => {
        onChange(e, child);
        onChangeEffect?.(e.target.value as T, child);
      }}
      value={value}
      error={error}
      selectRef={ref}
    />
  );
};
